export const name = 'tpaWorkerFeature' as const
